export default __webpack_public_path__ + "static/media/carousel-img-6.5abae546.webp";